import React, { useState } from "react";
import { USD_TO_VND_RATE, getConcurrencyByLimit, getUnitPriceByRequestCount } from "../../ultils";
import { ArrowDown, ArrowUp } from "lucide-react";

const PriceUpdateAnnouncement = ({ updates }) => {
    const [expandedIdx, setExpandedIdx] = useState(null);
    const sortedUpdates = [...updates].reverse();
    return (
        <div className="w-full p-4 rounded-2xl shadow-lg border bg-white animate-fade-in flex flex-col gap-1">
            <h2 className="text-xl font-extrabold text-center text-yellow-600 tracking-wide mb-2">Price Changes Announcements</h2>
            {sortedUpdates.map((item, idx, arr) => {
                let percentChange = 0;
                if (idx < arr.length - 1) {
                    const prev = arr[idx + 1].basePriceVND;
                    percentChange = ((item.basePriceVND - prev) / prev) * 100;
                }
                const isExpanded = expandedIdx === idx;
                return (
                    <div key={idx} className="mb-1 p-2 rounded-xl border bg-yellow-50 shadow flex flex-col gap-1">
                        <div className="flex items-center gap-2 cursor-pointer" onClick={() => setExpandedIdx(isExpanded ? null : idx)}>
                            {idx === 0 && <span className="text-sm font-semibold text-yellow-500">(Latest)</span>}
                            <div className="text-sm text-gray-700">BasePrice: <b>${(item.basePriceVND / USD_TO_VND_RATE).toFixed(5)} ({item.basePriceVND.toLocaleString()}đ)</b> </div>
                            <span className={`flex items-center text-sm font-semibold ${percentChange > 0 ? 'text-red-600' : 'text-green-600'}`}>({Math.abs(percentChange).toFixed(0)}% {percentChange > 0 ? <ArrowUp className="w-4 h-4"/> : <ArrowDown className="w-4 h-4"/>})</span>
                            <span className="text-sm text-gray-700">Announced: <b>{item.announceDate}</b></span>
                            <span className="text-sm text-gray-700">Effectived: <b>{item.effectiveDate}</b></span>
                            <span className="ml-auto text-xs px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 transition">{isExpanded ? "Hide" : "Details"}</span>
                        </div>
                        {isExpanded && (
                            <>
                                <div className="text-sm text-gray-700">Formula: Unit_Price = <strong>{(item.basePriceVND / USD_TO_VND_RATE).toFixed(5)}</strong> + 11430 / (Requests_Limit + 10000)</div>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-2">
                                    {[10000, 100000, 500000].map((limit, i) => {
                                        const concurrency = getConcurrencyByLimit(limit, item.basePriceVND);
                                        const unit_price_usd = getUnitPriceByRequestCount(limit, item.basePriceVND);
                                        const unit_price_vnd = unit_price_usd * USD_TO_VND_RATE;
                                        const price_usd = unit_price_usd * limit;
                                        const price_vnd = unit_price_vnd * limit;
                                        return (
                                            <div key={i} className="flex flex-col items-center p-1 border rounded-xl bg-white shadow">
                                                <div className="font-bold text-blue-600 mb-1">Example #{i + 1}</div>
                                                <div className="text-xs text-gray-600">Requests Limit: <b>{limit.toLocaleString()}</b></div>
                                                <div className="text-xs text-gray-600">Concurrency: <b>{concurrency}</b></div>
                                                <div className="text-xs text-gray-600">Monthly Price: <b>{price_usd.toFixed(2)} USD</b></div>
                                                <div className="text-xs text-gray-600">Giá tháng: <b>{price_vnd.toFixed(2)}đ</b></div>
                                                <div className="text-xs text-gray-600">Unit Price: <b>{unit_price_usd.toFixed(4)} USD</b></div>
                                                <div className="text-xs text-gray-600">Đơn giá: <b>{unit_price_vnd.toFixed(4)}đ</b></div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default PriceUpdateAnnouncement;
